var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 28.7882C45.4162 22.9542 38.3502 17.1202 20.8383 16.692C19.688 16.664 18.75 17.5982 18.75 18.7488C18.75 27.2842 18.75 59.5978 18.75 69.1545C18.75 70.3049 19.6881 71.2086 20.8381 71.2461C38.3502 71.8186 45.4162 79.5828 50 85.417M50 28.7882C54.5837 22.9542 61.6496 17.1202 79.1617 16.692C80.3121 16.664 81.25 17.5772 81.25 18.7278C81.25 28.2689 81.25 59.6103 81.25 69.1515C81.25 70.302 80.3121 71.2086 79.1621 71.2461C61.65 71.8186 54.5837 79.5828 50 85.417M50 28.7882V85.417",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1458 25H89.582C90.7324 25 91.6654 25.9327 91.6654 27.0833V81.4125C91.6654 83.0983 89.6791 84.2183 88.1383 83.5337C84.8254 82.0617 79.2966 80.2633 72.0574 80.2633C59.8024 80.2633 49.9987 87.5 49.9987 87.5C49.9987 87.5 40.1948 80.2633 27.9399 80.2633C20.7006 80.2633 15.1719 82.0617 11.859 83.5337C10.3182 84.2183 8.33203 83.0983 8.33203 81.4125V27.0833C8.33203 25.9327 9.26478 25 10.4154 25H19.8517",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaEducation);
export default __webpack_public_path__ + "static/media/area_education.1ebb8a70c7ed6b3717be72982f584bb7.svg";
export { ForwardRef as ReactComponent };